import { ReactNode } from 'react';
import { Box, Typography } from '@material-ui/core';

/** Компактная заглушка пустой таблицы на главной (вместо полноразмерного EmptyState). */
export const EmptyRows = ({
  text,
  action,
}: {
  text: string;
  action?: ReactNode;
}) => (
  <Box p={2} display="flex" alignItems="center" justifyContent="space-between">
    <Typography variant="body2" color="textSecondary">
      {text}
    </Typography>
    {action}
  </Box>
);
